export default "__VITE_ASSET__066e17ee__"